export default __webpack_public_path__ + "static/media/img_fee_70.ca4d40e7.svg";